import _ from 'lodash';

import { getCountry } from '../../../../iwIntlProvider/CountryProvider';
import messages from '../CompanyDetails.messages';

// eslint-disable-next-line import/no-default-export
export default (values) => {
    let errors = {};

    if (getCountry() === 'UK' && !values.annualProfit) {
        errors = _.setWith(errors, 'annualProfit', messages.enterAnnualProfit);
    }

    if (!values.annualTurnover) {
        errors = _.setWith(
            errors,
            'annualTurnover',
            messages.enterAnnualTurnover
        );
    }

    if (!values?.tradingFrom?.day) {
        errors = _.setWith(
            errors,
            'tradingFrom.day',
            messages.enterTradingFrom
        );
    }

    if (!values?.tradingFrom?.month) {
        errors = _.setWith(
            errors,
            'tradingFrom.month',
            messages.enterTradingFrom
        );
    }

    if (!values?.tradingFrom?.year) {
        errors = _.setWith(
            errors,
            'tradingFrom.year',
            messages.enterTradingFrom
        );
    }

    return errors;
};
